// Tiny color helpers for procedural, flat-shaded models.

/** Lighten (amt > 0) or darken (amt < 0) a hex color. amt in [-1, 1]. */
export function shade(hex: number, amt: number): number {
  const r = (hex >> 16) & 0xff;
  const g = (hex >> 8) & 0xff;
  const b = hex & 0xff;
  const adj = (c: number) =>
    Math.max(0, Math.min(255, Math.round(c + 255 * amt)));
  return (adj(r) << 16) | (adj(g) << 8) | adj(b);
}

/** A hex color number → a `#rrggbb` CSS string (for swatches / DOM styling). */
export function toCssHex(c: number): string {
  return "#" + ((c >>> 0) & 0xffffff).toString(16).padStart(6, "0");
}

/** Deterministic pseudo-random in [0,1) from a seed — same input, same output on every client. */
export function rand(seed: number): number {
  const x = Math.sin(seed * 12.9898) * 43758.5453;
  return x - Math.floor(x);
}
